import { CircularProgress } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import structureService from "../../services/structure.service";
import { decode as base64_decode, encode as base64_encode } from "base-64";
export default function SearchBase() {
  let navigate = useNavigate();
  function query() {
    return new URLSearchParams(window.location.search);
  }
  React.useEffect(() => {
      //document.body.setAttribute("data-nav-stage", "landing");
    // console.log(
    //   query().get("date_from"),
    //   query().get("date_to"),
    //   query().get("guests"),
    //   query().get("dcode"),
    //   query().get("uuid"),
    //   query().get("lang")
    // );
    const searchBase = {
      date_from: query().get("date_from"),
      date_to: query().get("date_to"),
      kids: query().get("kids"), //solo da google
      id_structure: query().get("id_structure"), //valore ricevuto da google
      category: query().get("cat"), //ricevuto da google, deve guidare il crawler
      promo_code: "",
      rooms: [
        {
          id: "room_0",
          adults: parseInt(query().get("guests")),
          childs: [],
        },
      ],
      uuid: query().get("uuid"),
      lang: query().get("lang"),
      };
      if (searchBase.id_structure) {
          
          structureService.getStructureInfoFromId(`${searchBase.id_structure}`).then(
              (result) => {
                  result = result.data;
                  searchBase.uuid = result.uuid;
                  navigate("/Home/search_base/" + base64_encode(JSON.stringify(searchBase)));
              },
              (error) => { }
          );
          
      } else {
          navigate("/Home/search_base/" + base64_encode(JSON.stringify(searchBase)));
      }
    
  }, []);
    return <div data-nav-loading-indicator="true"><CircularProgress /></div>;
}
